import React, { useState } from 'react';
import PropTypes from 'prop-types';
import Button from '@welldev-group/rcl-button';
import Input from '@welldev-group/rcl-input';
import Icon from '@welldev-group/rcl-icon';
import { I18nText } from '@welldev-group/react-comp-lib';
import Modal from '@welldev-group/rcl-modal';
import routes from '../../../shared/routes';
import httpClient from '../../../shared/libraries/httpClient';

const InvoiceCancelModal = ({ invoiceId, title }) => {
  const [modalOpen, setModalOpen] = useState(false);
  const [reason, setReason] = useState(null);
  const [reasonError, setReasonError] = useState(null);

  const onModalClose = () => {
    setModalOpen(false);
  };

  const onModalOpen = () => {
    setModalOpen(true);
  };

  const cancelInvoice = async () => {
    try {
      const { data } = await httpClient.delete(
        routes.billing.invoices.delete({
          id: invoiceId,
          cancellation_reason: reason,
        }),
      );

      if (data.redirectUrl) {
        window.location.replace(data.redirectUrl);
      }
    } catch (error) {
      const response = error.response;
      if (response && response.status === 422) {
        setReasonError(response.data.error.cancellationReason);
      } else {
        throw error;
      }
    }
  };

  const onChangeReason = value => {
    setReason(value);
  };

  return (
    <>
      <Button
        version="v2"
        size="small"
        className="button button--v2 button--small button--primary modal-toggle billing-invoice-cancel__button"
        fullWidth={false}
        type="primary"
        label={<I18nText id="billing.invoices.cancel.text" />}
        onClick={onModalOpen}
      />
      <Modal
        className="modal__wrapper modal__wrapper-small"
        isVisible={modalOpen}
        onOutsideClick={onModalClose}
      >
        <div>
          <div className="col-12 col-bleed-y modal__header">
            <Modal.Title>
              {I18n.t('components.billing.invoices.cancel.header', {
                title,
              })}
            </Modal.Title>
            <div
              onClick={onModalClose}
              onKeyDown={onModalClose}
              role="presentation"
            >
              <Icon name="close" size="normal" />
            </div>
          </div>
          <Modal.Content>
            <div className="col-12 col-bleed-y">
              <Input
                label={<I18nText id="billing.invoices.cancel.reason" />}
                value={reason}
                onChange={onChangeReason}
                error={reasonError}
                size="small"
              />
            </div>
          </Modal.Content>
          <Modal.Footer>
            <div className="col-12 billing-invoice-cancel-modal__actions">
              <Button
                version="v2"
                type="primary"
                size="small"
                label={<I18nText id="billing.invoices.cancel.text" />}
                onClick={cancelInvoice}
                disabled={!reason || reason.trim() === ''}
              />
              <Button
                version="v2"
                size="small"
                label={I18n.t('shared.action.cancel')}
                onClick={() => setModalOpen(false)}
              />
            </div>
          </Modal.Footer>
        </div>
      </Modal>
    </>
  );
};

InvoiceCancelModal.propTypes = {
  invoiceId: PropTypes.number.isRequired,
  title: PropTypes.string.isRequired,
};

export default InvoiceCancelModal;
